export const replaceNbsps = (str: string): string => str.replace(/\u00A0/g, ' ');
